import styled from 'styled-components';

export const TotalDivContainer = styled.div`
  width: 100%;

  h4 {
    margin: 0 0 var(--space-l);

    color: var(--grey7);

    font-size: 1.08rem;
    font-weight: 800;
    line-height: 1.2;
    letter-spacing: -0.01em;
  }
`;

export const SummaryContent = styled.div`
  display: flex;
  flex-direction: column;

  gap: var(--space-s);

  .summary-row,
  .tax-row,
  .total-row {
    display: flex;
    align-items: center;
    justify-content: space-between;

    gap: var(--space-m);
  }

  .summary-row,
  .tax-row {
    color: var(--grey4);

    font-size: 0.87rem;
    font-weight: 500;
  }

  .italicSpan,
  .tax-amount {
    color: var(--grey6);

    font-weight: 700;
  }

  .tax-span {
    margin-top: calc(var(--space-xs) * -1);

    color: var(--grey3);

    font-size: 0.72rem;
    font-style: italic;
    line-height: 1.4;
  }

  .tax-label-select {
    display: flex;
    align-items: center;

    gap: var(--space-xs);
  }

  .tax-label-select select {
    min-width: 72px;

    padding: 0.35rem 0.55rem;

    color: var(--grey6);

    background: var(--white);

    border: 1px solid var(--grey1);
    border-radius: var(--borderRadiusButton);

    font-size: 0.78rem;
    font-weight: 600;

    cursor: pointer;
  }

  .tax-label-select select:focus {
    outline: 2px solid var(--yellow3);
    outline-offset: 2px;

    border-color: var(--yellow4);
  }

  .total-row {
    margin-top: var(--space-s);
    padding-top: var(--space-l);

    color: var(--grey7);

    border-top: 1px solid var(--grey1);

    font-size: 1.05rem;

    strong {
      font-weight: 800;
    }

    span:last-child strong {
      font-size: 1.25rem;
    }
  }

  @media screen and (max-width: 600px) {
    gap: var(--space-xs);

    .summary-row,
    .tax-row {
      font-size: 0.82rem;
    }

    .total-row {
      margin-top: var(--space-xs);
      padding-top: var(--space-m);
    }

    .total-row span:last-child strong {
      font-size: 1.15rem;
    }
  }
`;
